import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";

export function ChangePasswordCard() {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) return toast.error("As senhas não coincidem");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Senha alterada com sucesso!");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="card-crisp p-6 space-y-4" data-testid="change-password-card">
      <div className="flex items-center gap-2"><LockKey size={20} weight="duotone" className="text-indigo-600" /><h3 className="font-heading font-semibold text-lg">Alterar senha</h3></div>
      <div className="grid sm:grid-cols-3 gap-4">
        <div><Label>Senha atual</Label><Input type="password" required value={form.current} onChange={set("current")} className="mt-1" data-testid="pw-current" /></div>
        <div><Label>Nova senha</Label><Input type="password" required minLength={6} value={form.next} onChange={set("next")} className="mt-1" data-testid="pw-new" /></div>
        <div><Label>Confirmar nova senha</Label><Input type="password" required minLength={6} value={form.confirm} onChange={set("confirm")} className="mt-1" data-testid="pw-confirm" />
          {form.confirm && form.next !== form.confirm && <p className="text-xs text-rose-600 mt-1" data-testid="pw-mismatch">As senhas não coincidem</p>}</div>
      </div>
      <Button type="submit" disabled={busy || (form.confirm && form.next !== form.confirm)} variant="outline" data-testid="pw-submit">{busy ? "Salvando..." : "Alterar senha"}</Button>
    </form>
  );
}
